import React, { useLayoutEffect } from 'react';
import '../styles/PrivacyPolicy.scss';
import { Helmet } from 'react-helmet-async';

function PrivacyPolicy() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Lily Lai Real Estate</title>
        <meta name="description" content="Read the privacy policy for Lily Lai Real Estate. Learn how we handle your personal information with transparency and care." />
        <link rel="canonical" href="https://www.lilylaisf.com/privacypolicy" />
      </Helmet>
      <div className='privacy-policy'>
        <div className='privacy-inner'>
          <p className='privacy-eyebrow'>Legal</p>
          <h1>Privacy Policy</h1>
          <p className='privacy-date'>Effective April 2026</p>

          <p>This Privacy Policy describes how Lily Lai Real Estate ("we," "us," or "our") collects, uses, and protects information you provide when visiting <strong>lilylaisf.com</strong>. By using this website, you agree to the practices described below.</p>

          <h2>Information We Collect</h2>
          <p>We only collect information you voluntarily provide through the contact and home valuation forms on this site. This may include:</p>
          <ul>
            <li>Your first and last name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Property address (for home valuation requests)</li>
            <li>Any message or questions you submit</li>
          </ul>
          <p>We do not collect any information automatically, and we do not use cookies or tracking technologies on this website.</p>

          <h2>How We Use Your Information</h2>
          <p>Information you submit is used solely to respond to your inquiry or provide the home valuation service you requested. We will not sell, rent, or share your personal information with third parties for marketing purposes.</p>

          <h2>Third-Party Services</h2>
          <p>This website uses the following third-party services to operate:</p>
          <ul>
            <li><strong>Resend</strong> — used to deliver form submissions to our inbox. Your submitted information is transmitted through Resend's servers. Please refer to <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noreferrer">Resend's Privacy Policy</a> for details.</li>
            <li><strong>Google reCAPTCHA</strong> — used to protect forms from spam. reCAPTCHA collects hardware and software information to verify you are human. Please refer to <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google's Privacy Policy</a> for details.</li>
          </ul>

          <h2>Data Retention</h2>
          <p>We retain the information you submit only as long as necessary to respond to your inquiry. We do not store your information in any database on this website.</p>

          <h2>External Links</h2>
          <p>This website may contain links to external sites such as social media platforms. We are not responsible for the privacy practices of those sites and encourage you to review their policies directly.</p>

          <h2>Children's Privacy</h2>
          <p>This website is not directed to children under the age of 13. We do not knowingly collect personal information from minors.</p>

          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be reflected on this page with an updated effective date.</p>

          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please reach out:</p>
          <ul>
            <li>Email: <a href="mailto:lily@lilylaisf.com">lily@lilylaisf.com</a></li>
            <li>Phone: <a href="tel:4157282623">415.728.2623</a></li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
